import { render, staticRenderFns } from "./HourSelector.vue?vue&type=template&id=06cafe03&scoped=true&"
import script from "./HourSelector.vue?vue&type=script&lang=ts&"
export * from "./HourSelector.vue?vue&type=script&lang=ts&"
import style0 from "./HourSelector.vue?vue&type=style&index=0&id=06cafe03&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06cafe03",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/opt/build/repo/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTimePicker } from 'vuetify/lib'
installComponents(component, {VTimePicker})
